import React from 'react';
import { useField } from 'formik';
import Form from 'react-bootstrap/Form';
import styles from './lifestage.module.scss';
import active from '../../../../assets/getstartedflow/activity/active.png';
import lazy from '../../../../assets/getstartedflow/activity/lazy.png';
import typical from '../../../../assets/getstartedflow/activity/typical.png';

export enum InputAlign {
  LEFT = 'left',
  CENTER = 'center',
}

interface BreedProps {
  // name: string;
  // inputAlign?: InputAlign;
}
const activityList = [
  {
    image: lazy,
    label1: 'Lazy Bones',
    label2:
      ' Get’s an  average of 20 mins walkies a day, and lots of couch time!',
    value: 'lazy_bones',
  },
  {
    image: typical,

    label1: 'Typical Activity',
    label2: 'Gets approx 40 mins walkies & some extra outdoor time!',
    value: 'typical',
  },
  {
    image: active,
    label1: 'Active',
    label2:
      'Gets about 1-2hrs exercise and is also pretty active during the day',
    value: 'active',
  },
];
const Activity: React.FC<BreedProps> = props => {
  const [field, meta, helpers] = useField('activity');
  const { setValue, setTouched } = helpers;

  const setLifestage = (value: string) => {
    setValue(value);
    setTouched(true);
  };
  // };
  const value = meta?.value || '';
  return (
    <Form.Group controlId="formBreed" className={'align-col-cen'}>
      <Form.Label className='form-label'>Activity levels</Form.Label>
      <div className={styles.lifestageContainer}>
        {activityList.map((it, index) => (
          <label className={styles.stageItem} key={'activity' + index}>
            <input
              type="radio"
              value={it.value}
              name="activity"
              checked={value == it.value}
              onClick={e => setLifestage(e.target.value)}
            />
            <div className="box">
              <div className="image-container">
                <img className="type-image" src={it.image} />
              </div>
              <div className="text-container">
                <div className="primary-text">{it.label1}</div>
                <div className="secondary-text">{it.label2}</div>
              </div>
            </div>
          </label>
        ))}
      </div>
    </Form.Group>

  );
};

export default Activity;
